import NarinLayout from "components/NarinLayout";
import ReadOnlyLayout from "components/Desktop/ReadOnlyLayout";

const ReturnPolicy = () => {
  return (
    <NarinLayout>
      <ReadOnlyLayout title="การเปลี่ยนคืนสินค้า">
        <div className="text-base md:text-2xl font-semibold">
          รับเปลี่ยนคืนสินค้า 100% ทั้ง กรณีสินค้าเสียหายจากการขนส่ง
          และกรณีสินค้าใกล้หมดอายุ โดยมีเงื่อนไขดังนี้
        </div>
        <ol className="text-base md:text-xl space-y-8">
          <li>
            กรณีสินค้าเสียหายจากการขนส่งหรือจากสาเหตุอื่น
            กรุณาแจ้งทางร้านให้รับทราบภายใน 3 วัน หลังจากรับสินค้า หากเกินกว่า 3
            วัน ทางร้านขอสงวนสิทธิ์ไม่รับเปลี่ยนคืน
          </li>
          <li>
            กรณีสินค้าใกล้หมดอายุ กรุณาแจ้งทางร้านให้รับทราบภายใน 7 วัน
            หลังจากรับสินค้า หากเกินกว่า 7 วัน
            ทางร้านขอสงวนสิทธิ์ไม่รับเปลี่ยนคืน
          </li>
          <li>
            กรณีอื่นๆนอกเหนือจาก ข้อ 1 และ ข้อ 2 กรุณาแจ้งทางร้านให้รับทราบภายใน
            10 วัน หลังจากรับสินค้า หากเกินกว่า 10 วัน
            ทางร้านขอสงวนสิทธิ์ไม่รับเปลี่ยนคืน
          </li>
          <li>ลูกค้าเป็นผู้รับผิดชอบค่าส่งสินค้ากลับ</li>
          <li>
            หลังจากได้รับสินค้าเปลี่ยนคืนจากลูกค้า
            ทางร้านจะดำเนินการส่งสินค้าใหม่ไปให้ทันที หากกรณีสินค้าหมด
            ทางร้านจะโอนเงินคืนเต็มจำนวน เพื่อป้องกันการแอบอ้าง
            และประโยชน์ของลูกค้าเอง ทางร้านจะโอนเงินคืนเข้าบัญชี
            ในชื่อของผู้สมัครสมาชิกเท่านั้น
          </li>
        </ol>
      </ReadOnlyLayout>
    </NarinLayout>
  );
};

export default ReturnPolicy;
